<template>
  <div class="">
    <!-- Título principal -->
    <div class="my-6">
      <h1 class="text-2xl font-bold text-gray-800 mb-2">
        Crear Solicitud de Pago
      </h1>
    </div>

    <!-- Layout en dos columnas sin v-row -->
    <div class="grid grid-cols-2 xl:grid-cols-2 gap-6 xl:gap-8">
      <!-- Columna izquierda - Documentación -->
      <div class="space-y-4 xl:space-y-6">
        <!-- Información del endpoint -->
        <div class="bg-white rounded-lg border border-gray-200 p-4 xl:p-6">
          <h3 class="text-lg xl:text-xl font-semibold mb-3 flex items-center">
            <span
              class="bg-blue-100 text-blue-800 px-2 py-1 rounded text-sm xl:text-base font-mono mr-3"
              >POST</span
            >
            https://sb-wee.ar/v1/checkout
          </h3>
          <p class="text-gray-600 text-sm xl:text-base mb-2">
            Crea una nueva solicitud de pago.
          </p>
        </div>

        <!-- Parámetros -->
        <h4 class="font-semibold mb-3 xl:mb-4 text-base xl:text-lg">
          Request
        </h4>

        <!-- Headers Table -->
        <DynamicTable
          title="Headers"
          :headers="headersConfig"
          :data="headersData"
          height="auto"
        />

        <!-- Body Table -->
        <DynamicTable
          title="Body"
          :headers="bodyConfig"
          :data="bodyParameters"
          height="150px"
        />
        <!-- Items -->
        <DynamicTable
          title="Atributos del objeto items."
          :headers="itemsBody"
          :data="itemsData"
          height="auto"
        />

        <!-- Response -->
        <h4 class="font-semibold mb-3 xl:mb-4 text-base xl:text-lg">
          Response
        </h4>

        <DynamicTable
          title="Atributos del objeto de la respuesta."
          :headers="responseHeaders"
          :data="responseData"
          height="auto"
        />

        <DynamicTable
          title="Atributos del objeto de data."
          :headers="responseHeadersData"
          :data="responseObjectData"
          height="150px"
        />

        <DynamicTable
          title="Atributos del objeto items."
          :headers="responseHeadersItems"
          :data="responseObjectItems"
          height="200px"
        />
      </div>

      <!-- Columna derecha - Ejemplos de código -->
      <div class="space-y-4 xl:space-y-6">
        <!-- Request Example -->

        <div class="bg-white rounded-lg border border-gray-200 p-3 xl:p-6">
          <h4 class="text-lg xl:text-xl font-semibold mb-3 flex items-center">
            Headers
          </h4>
          <span class="text-black">
            <p>
              <code class="text-black">Content-Type: application/json</code>
            </p>
            <p>
              <code class="text-black">Authorization: API Key</code>
            </p>
          </span>
        </div>

        <CodeBlock
          title="Example Request"
          :code="requestExample"
          language="json"
          status="success"
          :is-large="true"
          :request="true"
        />

        <!-- Response Example -->
        <CodeBlock
          title="Example Response"
          :code="responseExample"
          language="json"
          status="info"
          :is-large="true"
        />

        <div class="bg-white rounded-lg border border-gray-200 p-3 xl:p-6">
          <h4 class="text-lg xl:text-xl font-semibold mb-3 flex items-center">
            <i class="fa fa-exclamation-circle mr-2"></i>
            Nota
          </h4>
          <p class="text-gray-600 text-sm xl:text-base mb-2">
            Cuando recibe la respuesta para ingresar al CheckOut debe copiar el
            valor del atributo "checkout_url" de la respuesta e ingresarla en el
            navegador.
          </p>
        </div>
      </div>
    </div>
    <!-- Título principal -->
    <div class="my-6">
      <h1 class="text-2xl font-bold text-gray-800 mb-2">
        Redirecciones de la Transacción
      </h1>
    </div>

    <div class="bg-white rounded-lg border border-gray-200 p-4 xl:p-6">
      <p class="text-gray-600 text-sm xl:text-base mb-2">
        Se configuran las URLs de las páginas de respuesta para cuando una
        transacción es aprobada o pendiente. Estos campos no son obligatorios, y
        en caso de no especificar una URL, se redireccionará a la página de
        respuesta por defecto de WEE!
      </p>

      <div class="flex items-center gap-4 justify-between mb-4">
        <div>
          <h5 class="text-sm xl:text-lg font-semibold flex items-center">
            Si la compra es exitosa, tus usuarios serán dirigidos a:
          </h5>
        </div>
        <div class="flex flex-col items-center">
          <code
            class="text-xs xl:text-sm bg-gray-100 p-2 rounded text-green-600 mb-1"
          >
            Ejemplo: https://sb-wee.ar/v1/success
          </code>
          <small class="text-[0.6rem] text-gray-400 italic">
            Tus pagadores regresarán a esta página al finalizar el proceso del
            pago
          </small>
        </div>
      </div>
      <div class="flex items-center gap-4 justify-between mb-2">
        <div>
          <h5 class="text-sm xl:text-lg font-semibold flex items-center">
            Si la compra queda pendiente, tus usuarios serán dirigidos a:
          </h5>
        </div>
        <div class="flex flex-col items-center">
          <code
            class="text-xs xl:text-sm bg-gray-100 p-2 rounded text-yellow-600 mb-1"
          >
            Ejemplo: https://sb-wee.ar/v1/pending
          </code>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import DynamicTable from "../shared/DynamicTable.vue";
import CodeBlock from "../shared/CodeBlock.vue";

export default {
  name: "CrearSolicitudPago",
  components: {
    DynamicTable,
    CodeBlock,
  },
  data() {
    return {
      // Configuración de headers para la tabla de Headers
      headersConfig: [
        { key: "atributo", label: "atributo", isCode: true },
        { key: "tipo", label: "TIPO" },
        { key: "requerido", label: "REQUERIDO" },
        { key: "pattern", label: "PATTERN" },
        { key: "descripcion", label: "DESCRIPCIÓN" },
      ],

      // Datos de headers
      headersData: [
        {
          atributo: "apiKey",
          tipo: "String",
          requerido: "Sí",
          pattern: "API Key",
          descripcion: "aa7943e1-a60c-99e7-8812-xxxxxxxxxxxx",
        },
        {
          atributo: "Content-Type",
          tipo: "String",
          requerido: "Sí",
          pattern: "application/json",
          descripcion:
            "El tipo MIME del contenido del cuerpo enviado. Por defecto JSON es Unicode UTF-8. No se debe configurar otro charset.",
        },
        {
          atributo: "Cache-Control",
          tipo: "String",
          requerido: "Sí",
          pattern: "no-cache",
        },
      ],

      // Configuración de headers para la tabla de Body
      bodyConfig: [
        { key: "atributo", label: "ATRIBUTO", isCode: true },
        { key: "tipo", label: "TIPO" },
        { key: "requerido", label: "REQUERIDO" },
        { key: "descripcion", label: "DESCRIPCIÓN" },
      ],

      // Datos de parámetros del body
      bodyParameters: [
        {
          atributo: "payer_name",
          tipo: "String",
          requerido: "Sí",
          descripcion: "Nombre del pagador.",
        },
        {
          atributo: "payer_type",
          tipo: "String",
          requerido: "No",
          descripcion: "Tipo de identificación (DNI o CUIL) del pagador.",
        },
        {
          atributo: "payer_number",
          tipo: "String",
          requerido: "No",
          descripcion: "Número de identificación del pagador.",
        },
        {
          atributo: "payer_email",
          tipo: "String",
          requerido: "Sí",
          descripcion: "Correo electrónico del pagador.",
        },
        {
          atributo: "description",
          tipo: "String",
          requerido: "Sí",
          descripcion: "Descripción de la solicitud de pago.",
        },
        {
          atributo: "first_total",
          tipo: "Integer",
          requerido: "Si",
          descripcion:
            "Monto total antes de vencimiento. Valor entero. Los dos últimos dígitos se consideran decimales.",
        },
        {
          atributo: "first_due_date",
          tipo: "String",
          requerido: "Si",
          descripcion: "Fecha de 1º Vencimiento. Formato dd/mm/aaaa.",
        },
        {
          atributo: "external_reference",
          tipo: "String o Integer",
          requerido: "Si",
          descripcion:
            "Este atributo se puede utilizar como referencia para identificar la solicitud de pago y sincronizar con tus sistemas de backend el origen de la operación.",
        },
        {
          atributo: "second_total",
          tipo: "Integer",
          requerido: "No",
          descripcion:
            "Monto total, valor entero. Los dos últimos dígitos se consideran decimales. Este valor se incluye solamente si existe fecha de 2º vencimiento.",
        },
        {
          atributo: "second_due_date",
          tipo: "String",
          requerido: "No",
          descripcion: "Fecha de 2º Vencimiento. Formato dd/mm/aaaa.",
        },
        {
          atributo: "payment_type",
          tipo: "String",
          requerido: "Si",
          descripcion: "Tipificación del cobro.",
        },
        {
          atributo: "items",
          tipo: "Array [Object]",
          requerido: "Si",
          descripcion: "Lista detallada de productos o servicios.",
        },
        {
          atributo: "notificacion_url",
          tipo: "String",
          requerido: "No",
          descripcion:
            "Url donde se va a notificar el pago, en caso de que el cliente tenga activado webhook dinámico.o",
        },
        {
          atributo: "redireccion_url_success",
          tipo: "String",
          requerido: "No",
          descripcion:
            "Url de redirección dinámica cuando el pago finaliza de forma exitosa/aprobada.",
        },
        {
          atributo: "redireccion_url_pending",
          tipo: "String",
          requerido: "No",

          descripcion:
            "Url de redirección dinámica cuando el pago finaliza de forma exitosa/pendiente.",
        },
      ],

      itemsBody: [
        { key: "atributo", label: "ATRIBUTO", isCode: true },
        { key: "tipo", label: "TIPO" },
        { key: "requerido", label: "REQUERIDO" },
        { key: "descripcion", label: "DESCRIPCIÓN" },
      ],

      itemsData: [
        {
          atributo: "quantity",
          tipo: "Integer",
          requerido: "Sí",
          descripcion: "Cantidad del producto o servicio.",
        },
        {
          atributo: "description",
          tipo: "String",
          requerido: "Sí",
          descripcion: "Descripción del producto o servicio.",
        },
        {
          atributo: "amount",
          tipo: "Integer",
          requerido: "Sí",
          descripcion: "Importe del producto o servicio.",
        },
        {
          atributo: "identifier",
          tipo: "String",
          requerido: "No",
          descripcion: "Identificador del producto o servicio.",
        },
      ],

      // Response

      responseHeaders: [
        { key: "atributo", label: "atributo", isCode: true },
        { key: "tipo", label: "TIPO" },
        { key: "descripcion", label: "DESCRIPCIÓN" },
      ],

      responseData: [
        {
          atributo: "data",
          tipo: "Object",
          descripcion: "Objeto con la información de la solicitud de pago.",
        },
        {
          atributo: "message",
          tipo: "String",
          descripcion: "Mensaje de respuesta.",
        },
        {
          atributo: "status",
          tipo: "Boolean",
          descripcion: "Estado de la respuesta.",
        },
      ],

      responseHeadersData: [
        { key: "atributo", label: "atributo", isCode: true },
        { key: "tipo", label: "TIPO" },
        { key: "descripcion", label: "DESCRIPCIÓN" },
      ],

      responseObjectData: [
        {
          atributo: "id",
          tipo: "Integer",
          descripcion: "Identificador único de pago.",
        },
        {
          atributo: "estado",
          tipo: "String",
          descripcion: "Estado inicial del pago.",
        },
        {
          atributo: "description",
          tipo: "String",
          descripcion: "Descripción del cobro indicado.",
        },
        {
          atributo: "first_due_date",
          tipo: "String",
          descripcion: "Fecha de vencimiento.",
        },
        {
          atributo: "first_total",
          tipo: "Integer",
          descripcion: "Monto total antes de vencimiento.",
        },
        {
          atributo: "second_due_date",
          tipo: "String",
          descripcion: "Fecha límite de validez del cobro..",
        },
        {
          atributo: "second_total",
          tipo: "Integer",
          descripcion: "Monto total luego de vencimiento.",
        },
        {
          atributo: "payer_email",
          tipo: "String",
          descripcion: "Correo electrónico del pagador.",
        },
        {
          atributo: "external_reference",
          tipo: "String",
          descripcion:
            "Este atributo se puede utilizar como referencia para identificar la solicitud de pago y sincronizar con tus sistemas de backend el origen de la operación.",
        },
        {
          atributo: "metadata",
          tipo: "String",
          descripcion: "Información agregada para uso externo.",
        },
        {
          atributo: "uuid",
          tipo: "String",
          descripcion: "Identificador único de checkout.",
        },
        {
          atributo: "checkout_url",
          tipo: "String",
          descripcion: "Dirección web de acceso al checkout.",
        },
        {
          atributo: "created_at",
          tipo: "String",
          descripcion: "Fecha de creacion de la solicitud de pago.",
        },
        {
          atributo: "items",
          tipo: "Array [Object]",
          descripcion:
            "Objeto JSON que se puede utilizar para listar todos los productos o servicios asociados a la solicitud de pago, para que sean incluidos como un detalle del comprobante de pago.",
        },
      ],

      responseHeadersItems: [
        { key: "atributo", label: "atributo", isCode: true },
        { key: "tipo", label: "TIPO" },
        { key: "descripcion", label: "DESCRIPCIÓN" },
      ],

      responseObjectItems: [
        {
          atributo: "quantity",
          tipo: "Integer",
          descripcion: "Cantidad del producto o servicio.",
        },
        {
          atributo: "description",
          tipo: "String",
          descripcion: "Descripción del producto o servicio.",
        },
        {
          atributo: "amount",
          tipo: "Integer",
          descripcion: "Monto del producto o servicio.",
        },
        {
          atributo: "identifier",
          tipo: "String",
          descripcion: "Identificador del producto o servicio.",
        },
      ],

      // Ejemplos de código
      requestExample: ` {
          "payer_name":"juan gomez",
          "payer_type": "DNI",
          "payer_number": "34543234",
          "payer_email": "juan.gomez@telco.com.ar",
          "description": "Pago impuestos - DGR nueva prue 30062022",
          "first_total": 1500,
          "first_due_date": "15-08-2022",
          "external_reference": "257370",
          "second_due_date": "30-08-2022",
          "second_total": 2000,
          "payment_type": "PAGO SERVICIO",
          "items": [
              { 
                "quantity": 1,
                "description":"Pago de impuesto al sello",
                "amount": 1000,
                "identifier": "11223344"
              },
              {
                "quantity": 1,
                "description":"Pago de impuesto al sello",
                "amount": 500,
                "identifier": "11223355"
              }
          ]
    }`,

      responseExample: `{
      "data": {
          "id": 578,
          "estado": "pending",
          "description": "Pago impuestos - DGR nueva prue 30062022",
          "first_due_date": "26-08-2022",
          "first_total": 15,
          "second_due_date": "30-08-2022",
          "second_total": 20,
          "payer_name": "juan gomez",
          "payer_email": "juan.gomez@telco.com.ar",
          "external_reference": "257370",
          "metadata": "",
          "uuid": "f930b9d5-2a54-4532-be33-1ec32b0b4afb",
          "checkout_url": "https://sb-wee.ar/v1/checkout/f930b9d5-2a54-4532-be33-1ec32b0b4afb",
          "pdf_url": "https://sb-wee.ar/v1/checkout/f930b9d5-2a54-4532-be33-1ec32b0b4afb",
          "created_at": "25-08-2022",
          "items": [
              {
              "quantity": 1,
              "description": "Pago de impuesto al sello",
              "amount": 10,
              "identifier": "11223344"
              },
              {
              "quantity": 1,
              "description": "Pago de impuesto al sello",
              "amount": 5,
              "identifier": "11223355"
              }
          ]
          },
          "message": "Solicitud de pago generada",
          "status": true
        }`,
    };
  },
};
</script>

<style scoped>
/* Responsive adjustments para el grid */
@media (max-width: 1279px) {
  .grid-cols-1.xl\:grid-cols-2 {
    grid-template-columns: 1fr;
  }
}
</style>
